<div class="container-fluid footer mt-5">
	<div class="container">
		<div class="row py-2">
			<div class="col">
				<img src="assets/img/doj-main-header-logo.svg" height="60" alt="U.S. Department of Justice Logo" class="py-1" />
			</div>
			<div class="col">
				<ul class="nav flex-column">
					<li class="nav-item">
						<a class="nav-link" href="https://www.justice.gov/about" target="_blank">About</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="https://www.justice.gov/jmd/vulnerability-disclosure-policy" target="_blank"
							>Vulnerability Disclosure</a
						>
					</li>
				</ul>
			</div>
			<div class="col">
				<ul class="nav flex-column">
					<li class="nav-item">
						<a class="nav-link" href="https://www.justice.gov/accessibility/accessibility-information" target="_blank">Accessibility</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="https://www.justice.gov/jmd/eeo-program-status-report" target="_blank">No FEAR Act Data</a>
					</li>
				</ul>
			</div>
			<div class="col">
				<ul class="nav flex-column">
					<li class="nav-item">
						<a class="nav-link" href="https://www.justice.gov/oip" target="_blank">FOIA</a>
					</li>
					<!-- <li class="nav-item">
						<a class="nav-link" href="#" target="_blank">Privacy Policy</a>
					</li> -->
				</ul>
				<div class="text-end">version: 1.0.0</div>
			</div>
		</div>
	</div>
</div>
